import React from 'react'
import Link from 'next/link'
import { Media } from '@/payload-types'
import Image from 'next/image'
import { isMedia } from '@/lib/utils'
import { Button } from '@/components'

type CardProps = {
  id: number
  title: string
  image?: number | Media | null
  lead?: string | null
  tags?: string[]
  href?: string
}

function Card({ id, title, lead, image, tags, href }: Readonly<CardProps>): React.ReactNode {
  return (
    <div
      key={id}
      className="relative group flex flex-col rounded-xl border overflow-hidden hover:shadow-md transition-shadow"
    >
      {image && isMedia(image) ? (
        <figure className="relative bg-muted aspect-video w-full">
          <Image src={image.url!} alt={image.alt || title} fill objectFit="cover" />
        </figure>
      ) : null}

      <div className="flex flex-col gap-3 p-4 pb-16 flex-1">
        {tags && tags.length > 0 ? (
          <div className="flex flex-wrap gap-1">
            {tags.map((tag) => (
              <span
                key={tag}
                className="text-xs font-medium px-2 py-0.5 rounded-full bg-primary/10 text-primary"
              >
                {tag}
              </span>
            ))}
          </div>
        ) : null}

        <h3 className="font-semibold text-base leading-tight">{title}</h3>
        {lead ? <p className="text-sm text-muted-foreground line-clamp-3">{lead}</p> : null}
        {href ? (
          <Link href={href} className="absolute inset-0 flex flex-col items-start p-4">
            <Button variant="default" className="mt-auto" asChild>
              <span>En savoir plus</span>
            </Button>
          </Link>
        ) : null}
      </div>
    </div>
  )
}

export { Card, type CardProps }
